import { Box, Button, Group, LoadingOverlay, Modal, Stack } from '@mantine/core'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

type GroupConfirmModalProps = {
  opened: boolean
  title: ReactNode
  confirmLabel: ReactNode
  confirmColor?: string
  isPending: boolean
  children: ReactNode
  onConfirm: () => void
  onClose: () => void
}

export const GroupConfirmModal = ({
  opened,
  title,
  confirmLabel,
  confirmColor,
  isPending,
  children,
  onConfirm,
  onClose
}: GroupConfirmModalProps) => {
  return (
    <Modal size="lg" title={title} opened={opened} onClose={onClose}>
      <Box pos="relative">
        <LoadingOverlay visible={isPending} />

        <Stack gap="md">{children}</Stack>

        <Group justify="end" mt="xl">
          <Button miw={120} variant="default" onClick={onClose}>
            <FormattedMessage id="cancel" />
          </Button>

          <Button
            miw={120}
            color={confirmColor}
            disabled={isPending}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </Group>
      </Box>
    </Modal>
  )
}
